import { CustomForm } from '../../../customForms.types';

export function makeBadgeText({ usage }: CustomForm): string {
  if (usage.length === 0) {
    return '';
  }

  return `Used in ${usage.length} flow${usage.length > 1 ? 's' : ''}`;
}
